import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { goBack } from 'connected-react-router'
import { ROUTES } from 'constants/routes'
import { FocusMode } from 'components'
import SegmentForm from '../SegmentForm/SegmentForm'

const SegmentFocusMode = (): React.ReactElement => {
  const dispatch = useDispatch()
  const onClose = useCallback(() => dispatch(goBack()), [dispatch])

  const match = useRouteMatch<{ id: string }>({ path: ROUTES.segmentView, exact: true })
  const id = match?.params.id ?? ''

  // eslint-disable-next-line react/display-name
  const WrappedSegmentForm = useMemo(
    () =>
      function SegmentFocusModeForm() {
        return <SegmentForm id={id} />
      },
    [id],
  )

  return (
    <FocusMode
      isOpen={match !== null}
      title={id === 'new' ? 'Create segment' : 'Edit segment'}
      ContentComponent={WrappedSegmentForm}
      onClose={onClose}
    />
  )
}

export default SegmentFocusMode
